import * as React from "react";
import { cn } from "../utils";

type TextareaBaseProps = React.ComponentProps<"textarea"> & {
  markdownPreview?: boolean;
  error?: boolean;
};

function Textarea({ className, rows, error, ...props }: TextareaBaseProps) {
  return (
    <textarea
      data-slot="textarea"
      rows={rows}
      aria-invalid={error || undefined}
      className={cn(
        "qodo qodo-textarea border-input px-3 py-2 focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:border-border-input-negative-idle",
        "dark:bg-fill-input-neutral-idle flex min-h-16 w-full rounded-md border bg-transparent",
        "border-border-interactive-neutral-idle shadow-none",
        "placeholder:text-purple-muted-400 text-purple-muted-300 outline-none focus-visible:ring-0 selection:bg-primary selection:text-primary-foreground disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-purple-muted-700 disabled:border-purple-muted-500 disabled:text-purple-muted-400 read-only:bg-fill-input-neutral-disabled read-only:border-border-input-neutral-disabled read-only:cursor-default md:text-sm",
        { "field-sizing-content": !rows },
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
